import { Chip } from "@mui/material";

import { TagInfo } from "../types";

export const RemovedTagChip = ({
  tagInfo,
  onRestore,
  theme,
}: {
  tagInfo: TagInfo;
  onRestore: (tagName: string) => void;
  theme: any;
}) => {
  return (
    <Chip
      label={tagInfo.name}
      onClick={() => onRestore(tagInfo.name)}
      variant="outlined"
      sx={{
        backgroundColor: "transparent",
        borderColor: theme.palette.grey[400],
        color: theme.palette.grey[600],
        cursor: "pointer",
        "&:hover": {
          backgroundColor: `${theme.palette.grey[400]}10`,
        },
      }}
    />
  );
};
